import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.staging.seek.com',
    clientDomain: 'talent.staging.seek.co.nz',
    clientId: 'YwG4eilP3JY067Z4EjlGCtLkEYl9hPpT',
    environment: 'dev',
    realm: 'Username-Password-Authentication',
    redirectPath: '/oauth/callback/',
    useRefreshTokens: true,
    contactUs: {
        en: 'https://talent.seek.co.nz/contactus/',
    },
    siteName: siteNames.employer.seek.nz,
    zone: getZoneFromSite(siteNames.employer.seek.nz),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=talent_staging_seek_co_nz.js.map